module.exports = __webpack_public_path__ + "img/shimfo_img_logo.69c0ca27.png";